import { createContext, createElement, useContext, useState } from "react";
import { Channel } from "./api/models";

export type ChannelContext = {
  channel: Channel;
  setChannel: (c: Channel) => void;
};

const ChannelContext = createContext<ChannelContext | undefined>(undefined);

function _useChannelState(): ChannelContext {
  const [channel, setChannel] = useState<Channel>("RES");
  return { channel, setChannel };
}

export function useChannelState() {
  const context = useContext(ChannelContext);
  if (context) return context;
  return _useChannelState();
}

export function Provider({ children }: { children: React.ReactNode }) {
  const state = useChannelState();
  return createElement(ChannelContext.Provider, { value: state }, children);
}
